// import React, { useEffect, useState } from "react";
// import { Applogo, profileLogo } from "../../../Routes/ImagePath";
// import { DatePicker } from "antd";
// import { Radio } from "react-feather";
// import { useNavigate } from "react-router-dom";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import { ErrorToast, SuccessToast } from "../../ToastComponent";

// export const CollectionOfModalPopup = ({collectionOfIMDFunc}) => {
  // const initialTableData = [
  //   {
  //     module: "Projects",
  //     read: true,
  //     write: true,
  //     create: true,
  //     delete: true,
  //     import: true,
  //     export: true,
  //   },
  //   {
  //     module: "Tasks",
  //     read: true,
  //     write: true,
  //     create: true,
  //     delete: true,
  //     import: true,
  //     export: true,
  //   },
  //   {
  //     module: "Chat",
  //     read: true,
  //     write: true,
  //     create: true,
  //     delete: true,
  //     import: true,
  //     export: true,
  //   },
  //   {
  //     module: "Estimates",
  //     read: true,
  //     write: true,
  //     create: true,
  //     delete: true,
  //     import: true,
  //     export: true,
  //   },
  //   {
  //     module: "Invoices",
  //     read: true,
  //     write: true,
  //     create: true,
  //     delete: true,
  //     import: true,
  //     export: true,
  //   },
  //   {
  //     module: "Timing Sheets",
  //     read: true,
  //     write: true,
  //     create: true,
  //     delete: true,
  //     import: true,
  //     export: true,
  //   },
  // ];

//   //   let yourDate = new Date()
//   // // yourDate.toISOString().split('T')[0]

//   // const today=(yourDate.toISOString().split('T')[0])

//   const [tableData, setTableData] = useState(initialTableData)

//   // const [userId,setUserId] = useState('')

//   // useEffect(() => {
//   //  const id= JSON.parse(sessionStorage.getItem('user'))
//   // setUserId(id)
//   // }, [])

//   const AllFileLoginData = async () => {
//     try {
//       const id = JSON.parse(sessionStorage.getItem('user'))?.id
//       console.log("id", id)
//       const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       console.log("response", response)
//     } catch (error) {
//       return error
//     }
//   }

//   useEffect(() => {
//     AllFileLoginData()
//   }, [])

//   // const [location, setLocation] = useState(null);

//   const [LocalFormData, setLocalFormData] = useState({

//     BranchId: "",
//     Name: "",
//     Mobile: "",
//     ReferenceNo: "",
//     IsIMDCollected:false,
//     ExpectedDate:"",
//     Latitude: "",
//     Longitude: "",
//   });

//   // const handleRadioChange = (e) => {
//   //   setRadioValue(e.target.value === 'true');

//   // };

//   const handleDateChange = (date) => {
//     setLocalFormData({ ...LocalFormData, ExpectedDate: date });
//   };

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {

//         const { latitude, longitude } = position.coords;
//         setLocalFormData({ ...LocalFormData, Latitude: latitude, Longitude: longitude });
//       });
//     } else {
//       console.log("Geolocation is not supported by this browser.");
//     }
//   }, [])

//   // console.log("location",location?.latitude)

//   const HandleSubmit =async () => {

//     const formatDateToUTC = (dateString) => {
//       const date = new Date(dateString);
//       const year = date.getUTCFullYear();
//       const month = String(date.getUTCMonth() + 1).padStart(2, '0');
//       const day = String(date.getUTCDate()).padStart(2, '0');
//       const hours = String(date.getUTCHours()).padStart(2, '0');
//       const minutes = String(date.getUTCMinutes()).padStart(2, '0');
//       const seconds = String(date.getUTCSeconds()).padStart(2, '0');
//       const milliseconds = String(date.getUTCMilliseconds()).padStart(3, '0');
//       return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
//     };

//     if (LocalFormData.Mobile.length !== 10) {
//       ErrorToast("Mobile Number must be exactly 10 digits.");
//       return;
//     }

// const formData = new FormData();
//     formData.append("BranchId", LocalFormData.BranchId);
//     formData.append("Name", LocalFormData.Name);
//     formData.append("Mobile", LocalFormData.Mobile);
//     formData.append("ReferenceNo", LocalFormData.ReferenceNo);
//     formData.append("IsIMDCollected", LocalFormData.IsIMDCollected);
//     // formData.append("ExpectedDate", formatDateToUTC(LocalFormData.ExpectedDate));
//     formData.append("Latitude", LocalFormData.Latitude);
//     formData.append("Longitude", LocalFormData.Longitude);
//     if (LocalFormData.IsIMDCollected === false) {
//       formData.append("ExpectedDate", formatDateToUTC(LocalFormData.ExpectedDate));
//     }

//     try {
//       const response = await axios.post(`${Api_Url}api/v1/CollectingIMD`,formData,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       console.log(response)
//       collectionOfIMDFunc()
//       SuccessToast("Collection Data Submitted Successfully")
//     } catch (error) {
//       return false;
//     }
//   }

//   const handleCheckboxChange = (module, column) => {
//     // Create a copy of the tableData
//     const updatedTableData = [...tableData];

//     // Find the row with the specified module
//     const row = updatedTableData.find((item) => item.module === module);

//     // Toggle the checkbox value
//     row[column] = !row[column];

//     // Set the updated data
//     setTableData(updatedTableData);
//   };

//   const [allbranch,setAllBranch] = useState('')

//   const AllBranchName=async () =>{
//     try {
//       const response = await axios.get(`${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       // console.log("response",response.data.data)
//       setAllBranch(response.data.data)
//     } catch (error) {
//       console.log("object",error)
//     }
//   }
//   console.log(allbranch)

//   useEffect(()=>{
//     AllBranchName()
//   },[])

//   const validateMobileNumber = (number) => {
//     const regex = /^[0-9]{0,10}$/;
//     return regex.test(number);
//   };

//   const handleMobileChange = (e) => {
//     const value = e.target.value;
//     if (validateMobileNumber(value)) {
//       setLocalFormData({
//         ...LocalFormData,
//         Mobile: value,
//       });
//     }}

//   return (
//     <>
//       <div id="add_client" className="modal custom-modal fade" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Collection Of IMD</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="profile-image text-center mt-4 mb-4">
//                 <img
//                   // src={{Applogo} ? {Applogo} : {profileLogo}}
//                   src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYP-KKtRJXm9qK7k2_PA1utxbxWdpzGIdulQ&s'
//                   alt='mohit'
//                   className="img-fluid rounded-circle"
//                   style={{ width: '100px', height: '100px' }}
//                 />
//               </div>

//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch && allbranch.length>0 && allbranch.map((res)=>(
//                         <option value={res.id}>{res.name}</option>
//                        ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Customer Name <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.Name} onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Mobile <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" value={LocalFormData.Mobile} onChange={handleMobileChange} />
//                     </div>
//                   </div>
//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       IMD Collected <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault1"
//                         value="true"
//                         checked={LocalFormData.IsIMDCollected === true}
//                         onChange={(e)=>setLocalFormData({...LocalFormData,IsIMDCollected:e.target.value === "true"})}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault1">
//                         Yes
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault2"
//                         value=""
//                         checked={LocalFormData.IsIMDCollected === false}
//                         onChange={(e)=>setLocalFormData({...LocalFormData,IsIMDCollected:e.target.value === "true"})}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault2">
//                         No
//                       </label>
//                     </div>
//                   </div>

//                   {/* Conditional rendering based on radio selection */}
//                   {LocalFormData.IsIMDCollected === true ? (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Refference Number <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           placeholder="Enter your reference number"
//                           className="form-control"
//                           type="text"
//                           value={LocalFormData.ReferenceNo}
//                           onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNo: e.target.value })}
//                         />
//                       </div>
//                     </div>
//                   ) : (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Expected Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.ExpectedDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>

//             </div>
//           </div>
//         </div>
//       </div>

//       <div id="edit_client" className="modal custom-modal fade" role="dialog">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Edit Client</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//             <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch && allbranch.length>0 && allbranch.map((res)=>(
//                         <option value={res.id}>{res.name}</option>
//                        ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Customer Name <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.Name} onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Mobile <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" value={LocalFormData.Mobile} onChange={(e) => setLocalFormData({ ...LocalFormData, Mobile: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       IMD Collected <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault1"
//                         value="true"
//                         checked={LocalFormData.IsIMDCollected === true}
//                         onChange={(e)=>setLocalFormData({...LocalFormData,IsIMDCollected:e.target.value === "true"})}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault1">
//                         Yes
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault2"
//                         value=""
//                         checked={LocalFormData.IsIMDCollected === false}
//                         onChange={(e)=>setLocalFormData({...LocalFormData,IsIMDCollected:e.target.value === "true"})}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault2">
//                         No
//                       </label>
//                     </div>
//                   </div>

//                   {/* Conditional rendering based on radio selection */}
//                   {LocalFormData.IsIMDCollected === true ? (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Refference Number <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           placeholder="Enter your reference number"
//                           className="form-control"
//                           type="text"
//                           value={LocalFormData.ReferenceNo}
//                           onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNo: e.target.value })}
//                         />
//                       </div>
//                     </div>
//                   ) : (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Expected Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.ExpectedDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// modal

import React, { useEffect, useState } from "react";
import { AllFormsUpperphoto, Applogo, profileLogo } from "../../../Routes/ImagePath";
import { DatePicker, Modal } from "antd";
import { Radio } from "react-feather";
import { useNavigate } from "react-router-dom";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../ToastComponent";

export const CollectionOfModalPopup = ({ collectionOfIMDFunc, onClose }) => {
  const initialTableData = [
    {
      module: "Projects",
      read: true,
      write: true,
      create: true,
      delete: true,
      import: true,
      export: true,
    },
    {
      module: "Tasks",
      read: true,
      write: true,
      create: true,
      delete: true,
      import: true,
      export: true,
    },
    {
      module: "Chat",
      read: true,
      write: true,
      create: true,
      delete: true,
      import: true,
      export: true,
    },
    {
      module: "Estimates",
      read: true,
      write: true,
      create: true,
      delete: true,
      import: true,
      export: true,
    },
    {
      module: "Invoices",
      read: true,
      write: true,
      create: true,
      delete: true,
      import: true,
      export: true,
    },
    {
      module: "Timing Sheets",
      read: true,
      write: true,
      create: true,
      delete: true,
      import: true,
      export: true,
    },
  ];
  const [tableData, setTableData] = useState(initialTableData);

  const AllFileLoginData = async () => {
    try {
      const id = JSON.parse(sessionStorage.getItem("user"))?.id;
      console.log("id", id);
      const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      console.log("response", response);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    AllFileLoginData();
  }, []);

  const [loading, setLoading] = useState(false); // State for loading indicator
  const [LocalFormData, setLocalFormData] = useState({
    BranchId: "",
    Name: "",
    Mobile: "",
    ReferenceNo: "",
    IsIMDCollected: false,
    ExpectedDate: "",
    Latitude: "",
    Longitude: "",
  });

  // const handleRadioChange = (e) => {
  //   setRadioValue(e.target.value === 'true');

  // };

  const handleDateChange = (date) => {
    setLocalFormData({ ...LocalFormData, ExpectedDate: date });
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setLocalFormData({
          ...LocalFormData,
          Latitude: latitude,
          Longitude: longitude,
        });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  // console.log("location",location?.latitude)

  const HandleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formatDateToUTC = (dateString) => {
      const date = new Date(dateString);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      const hours = String(date.getUTCHours()).padStart(2, "0");
      const minutes = String(date.getUTCMinutes()).padStart(2, "0");
      const seconds = String(date.getUTCSeconds()).padStart(2, "0");
      const milliseconds = String(date.getUTCMilliseconds()).padStart(3, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
    };

    if (
      !LocalFormData.BranchId ||
      !LocalFormData.Name ||
      !LocalFormData.Mobile ||
      LocalFormData.Mobile.length !== 10 
      // LocalFormData.IsIMDCollected
    ) {
      ErrorToast(
        "Please fill in all required fields and ensure the mobile number is 10 digits."
      );
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("BranchId", LocalFormData.BranchId);
    formData.append("Name", LocalFormData.Name);
    formData.append("Mobile", LocalFormData.Mobile);
    formData.append("ReferenceNo", LocalFormData.ReferenceNo);
    formData.append("IsIMDCollected", LocalFormData.IsIMDCollected);
    // formData.append("ExpectedDate", formatDateToUTC(LocalFormData.ExpectedDate));
    formData.append("Latitude", LocalFormData.Latitude);
    formData.append("Longitude", LocalFormData.Longitude);
    if (LocalFormData.IsIMDCollected === false) {
      formData.append(
        "ExpectedDate",
        formatDateToUTC(LocalFormData.ExpectedDate)
      );
    }

    try {
      const response = await axios.post(
        `${Api_Url}api/v1/CollectingIMD`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log(response);
      collectionOfIMDFunc();
      SuccessToast("Collection Data Submitted Successfully");
      onClose();
    } catch (error) {
      ErrorToast("An error occurred while submitting.");
    }
    setLoading(false);
  };

  const handleCheckboxChange = (module, column) => {
    // Create a copy of the tableData
    const updatedTableData = [...tableData];

    // Find the row with the specified module
    const row = updatedTableData.find((item) => item.module === module);

    // Toggle the checkbox value
    row[column] = !row[column];

    // Set the updated data
    setTableData(updatedTableData);
  };

  const [allbranch, setAllBranch] = useState("");

  const AllBranchName = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      // console.log("response",response.data.data)
      setAllBranch(response.data.data);
    } catch (error) {
      console.log("object", error);
    }
  };
  console.log(allbranch);

  useEffect(() => {
    AllBranchName();
  }, []);

  const validateMobileNumber = (number) => {
    const regex = /^[0-9]{0,10}$/;
    return regex.test(number);
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (validateMobileNumber(value)) {
      setLocalFormData({
        ...LocalFormData,
        Mobile: value,
      });
    }
  };

  return (
    <>
      <Modal
        title={<h4>Add IMD Collecton</h4>}
        open={true}
        onOk={onClose}
        onCancel={onClose}
        footer={[
          <div
            className="d-flex justify-content-between align-items-center"
            key="footer"
          >
            <button className="btn btn-danger submit-btn" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn-primary submit-btn"
              onClick={HandleSubmit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>,
        ]}
        width={600}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <div className="modal-body mt-5">
          <div className="profile-image text-center mt-4 mb-4">
            <img
              src={AllFormsUpperphoto}
              alt="Profile"
              className="img-fluid rounded-circle"
              style={{ width: "100px", height: "100px" }}
            />
          </div>
          <form>
            <div className="row">
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Branch <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={LocalFormData.BranchId}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        BranchId: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Branch</option>
                    {allbranch &&
                      allbranch.length > 0 &&
                      allbranch.map((res) => (
                        <option value={res.id}>{res.name}</option>
                      ))}
                    {/* Add more branches as needed */}
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Customer Name <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={LocalFormData.Name}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        Name: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Mobile <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    value={LocalFormData.Mobile}
                    onChange={handleMobileChange}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <label className="col-form-label">
                  IMD Collected <span className="text-danger">*</span>
                </label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                    value="true"
                    checked={LocalFormData.IsIMDCollected === true}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        IsIMDCollected: e.target.value === "true",
                      })
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault1"
                  >
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault2"
                    value=""
                    checked={LocalFormData.IsIMDCollected === false}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        IsIMDCollected: e.target.value === "true",
                      })
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault2"
                  >
                    No
                  </label>
                </div>
              </div>

              {/* Conditional rendering based on radio selection */}
              {LocalFormData.IsIMDCollected === true ? (
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Refference Number <span className="text-danger">*</span>
                    </label>
                    <input
                      placeholder="Enter your reference number"
                      className="form-control"
                      type="text"
                      value={LocalFormData.ReferenceNo}
                      onChange={(e) =>
                        setLocalFormData({
                          ...LocalFormData,
                          ReferenceNo: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              ) : (
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Expected Date <span className="text-danger">*</span>
                    </label>
                    <DatePicker
                      selected={LocalFormData.ExpectedDate}
                      onChange={handleDateChange}
                      className="form-control"
                    />
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};
